import React from 'react';
import { Table, Button } from 'react-bootstrap';
import { ThreeDots } from "react-loader-spinner";
import { toProperCase } from '../../utils/Common';

export default function PotentialUsersTable({ 
  potentialUsers, 
  loadingPotentialUsers, 
  caps, 
  handleAddUserToBuilder, 
  isMobile 
}) {
  if (loadingPotentialUsers) {
    return (
      <div className="d-flex justify-content-center">
        <ThreeDots color="#00BFFF" height={30} width={30} />
      </div>
    );
  }

  if (potentialUsers.length === 0) {
    return <p className="text-muted">No additional users found from this domain.</p>;
  }

  return (
    <Table bordered condensed hover className="shared-users-table">
      <thead>
        <tr>
          <th>User</th>
          <th>Last Login</th>
          <th>{isMobile ? "Access" : "Camera Access"}</th>
          <th>{isMobile ? "Actions" : "Quick Actions"}</th>
        </tr>
      </thead>
      <tbody>
        {potentialUsers.map(user => (
          <tr key={user.userId}>
            <td style={{ padding: '8px 12px', verticalAlign: 'middle' }}>
              <div style={{ textAlign: 'left', width: '100%' }}>
                <div style={{ fontWeight: 500, marginBottom: '2px', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{user.email}</div>
                {user.firstName && (
                  <div style={{ fontSize: '0.9em', color: '#666' }}>
                    {toProperCase(user.firstName)}{user.lastName ? ` ${toProperCase(user.lastName)}` : ''}
                  </div>
                )}
              </div>
            </td>
            <td className="shared-user-action-cell">
              {user.lastLogin ? new Date(user.lastLogin).toLocaleDateString() : 'More than a month ago'}
            </td>
            <td className="shared-user-action-cell">
              {user.caps ? caps.filter(cap => user.caps.some(uc => uc.capId === cap.capId)).length : 0} Cameras
            </td>
            <td className="shared-user-action-cell">
              <Button 
                bsSize={isMobile ? "xs" : "sm"}
                onClick={() => handleAddUserToBuilder(user.userId)}
                style={{ whiteSpace: 'normal', textAlign: 'center' }}
              >
                Mark as Employee
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
} 